module.exports = __webpack_public_path__ + "static/media/tier-gem-disabled.d0856b28.svg";